import * as React from 'react';

export const PlusIcon = () => {
  return (
    <svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 1.14941c0-.414209-.33579-.749996-.75-.749996s-.75.335787-.75.749996v4.49982H.75c-.414214 0-.75.33579-.75.75s.335786.75.75.75h4.5v4.50017c0 .4142.33579.75.75.75s.75-.3358.75-.75V7.14923h4.5c.4142 0 .75-.33579.75-.75s-.3358-.75-.75-.75h-4.5V1.14941z"
        fill="currentColor"
      />
    </svg>
  );
};
